/* eslint comma-dangle: ["error", "always-multiline"] */
/* eslint-disable no-magic-numbers */

import { equipmentPrettyType } from 'Utils/filters.js';

export default {
  fastWatch: true,
  enableColumnMoving: true,
  paginationPageSizes: [100, 200, 500, 1000],
  enableFiltering: true,
  showGridFooter: false,
  showColumnFooter: false,
  enableRowSelection: true,
  enableSelectAll: false,
  // Note that the selectAll does not watch for new data,
  // so you need to manually call grid.api.selection.selectAllVisibleRows if new data has been added.
  multiSelect: false,
  modifierKeysToMultiSelect: false,
  enableRowHeaderSelection: false,
  enableColumnResizing: true,
  enableGridMenu: true,
  gridMenuShowHideColumns: true,
  exporterMenuPdf: false,
  exporterMenuCsv: true,
  exporterMenuExcel: false,
  exporterMenuAllData: true,
  exporterMenuVisibleData: true,
  exporterMenuSelectedData: true,
  gridMenuCustomItems: [{
    title: 'Reset columns',
    action() {
      this.grid.appScope.resetGridState();
    },
    order: 210, // Columns are 300 -> 300 + numColumns * 2, importer and exporter are 150 and 200 respectively
  }],
  columnDefs: [{
    field: 'name',
    displayName: 'Name',
    cellClass: 'rtl',
    enableHiding: false,
    cellTooltip: true,
    enableCellEdit: false,
    width: '*',
    sort: { direction: 'asc' },
    // Natural sort (to handle eg "Thing 10" > "Thing 2")
    sortingAlgorithm: (a, b) => a.localeCompare(b, undefined, { numeric: true }),
  }, {
    field: 'equipmentType',
    displayName: 'Type',
    cellFilter: 'equipmentPrettyType',
    enableHiding: false,
    enableCellEdit: false,
    width: '10%',
    filter: {
      // This lets us filter by raw AND pretty type vs enabling filterCellFiltered
      condition: (searchTerm, type) => {
        const exp = new RegExp(searchTerm, 'i');
        return exp.test(type) || exp.test(equipmentPrettyType(type));
      },
    },
    sortingAlgorithm: (a, b) => equipmentPrettyType(a).localeCompare(equipmentPrettyType(b)),
  }, {
    field: 'settings.externalIp',
    displayName: 'External Address',
    enableCellEdit: false,
    width: '10%',
    cellClass: 'rtl',
    cellTemplate: `
      <div class="ui-grid-cell-contents">
        <clip-button
          ng-if="grid.getCellValue(row, col)"
          size="xs"
          txt="{{ grid.getCellValue(row, col) }}"
        ></clip-button>
        {{grid.getCellValue(row, col)}}
      </div>
    `,
  }, {
    field: 'settings.externalPort',
    displayName: 'External Port',
    enableCellEdit: false,
    width: '7%',
    cellClass: 'rtl',
    cellTemplate: `
      <div class="ui-grid-cell-contents">
        <clip-button
          ng-if="grid.getCellValue(row, col)"
          size="xs"
          txt="{{ grid.getCellValue(row, col) }}"
        ></clip-button>
        {{grid.getCellValue(row, col)}}
      </div>
    `,
  }, {
    field: 'settings.ip',
    displayName: 'IP',
    enableCellEdit: false,
    width: '10%',
    cellClass: 'rtl',
    cellTemplate: `
      <div class="ui-grid-cell-contents">
        <clip-button
          ng-if="grid.getCellValue(row, col)"
          size="xs"
          txt="{{ grid.getCellValue(row, col) }}"
        ></clip-button>
        {{grid.getCellValue(row, col)}}
      </div>
    `,
  }, {
    field: 'settings.httpAlt',
    displayName: 'Port',
    enableCellEdit: false,
    width: '7%',
    cellClass: 'rtl',
    cellTemplate: `
      <div class="ui-grid-cell-contents">
        <clip-button
          ng-if="grid.getCellValue(row, col)"
          size="xs"
          txt="{{ grid.getCellValue(row, col) }}"
        ></clip-button>
        {{grid.getCellValue(row, col)}}
      </div>
    `,
  }, {
    field: 'settings.timezone',
    displayName: 'Timezone',
    cellClass: 'rtl',
    enableCellEdit: false,
    width: '10%',
  }, {
    field: 'settings.latitude',
    displayName: 'Latitude',
    enableCellEdit: false,
    width: '7%',
  }, {
    field: 'settings.longitude',
    displayName: 'Longitude',
    enableCellEdit: false,
    width: '7%',
  }, {
    field: 'id',
    displayName: 'ID',
    enableCellEdit: false,
    cellTemplate: `
      <div class="ui-grid-cell-contents rtl">
        <clip-button
          size="xs"
          txt="{{ grid.getCellValue(row, col) }}"
        ></clip-button>
        {{grid.getCellValue(row, col)}}
      </div>
    `,
    width: '7%',
  }],
};
